import React, { useState } from 'react';
import smsIcon from "../../assets/sms.png"
import lockIcon from "../../assets/lock.png"
import statusIcon from "../../assets/status.png"

const EmailPopup = ({ onClose }) => {
    return (
        <div className="popup-overlay p-4">
            <div className="popup-content p-4">
                <img src={statusIcon} style={{width:"50px", height:"50px"}}/>
                <h5 className='sub-title my-4'>Check your new email to confirm
                this change. </h5>
                <p className='gray-text-for-content mb-4'>We will not change the email until the new email
                confirmation is completed.</p>
                <button onClick={onClose} className="dark-orange-button px-4" style={{fontSize:"15px"}}>Okay!</button>
            </div>
        </div>
    );
};

const ChangeEmail = () => {

     const [showPopup, setShowPopup] = useState(false);

     const handleSubmit = (e) => {
        e.preventDefault();
        setShowPopup(true);
    };
    
     const handlePopupClose = () => {
        setShowPopup(false); 
    };

    return (
        <div className='mt-4'>

            <form onSubmit={handleSubmit}  className="mb-4 bg-white rounded">
                <h5 className="mb-2 sub-title">Change Email</h5>
                <p className="gray-text-for-content mb-4">Update your password to a password you have not previously used.</p>
                <div className='row'>
    
                    <div className="mb-4 col-4">
                        <label className="d-block text-start">New Email</label>
                        <div className="position-relative">
                            <input
                                type="email"
                                required
                                placeholder="Enter new email"
                                className="input-base gray-text-for-content"

                            />
                            <div className="input-start-icon-image"><img src={lockIcon} alt="" /></div>
                        </div>
                    </div>
                    <div className="mb-4 col-4">
                        <label className="d-block text-start">Password</label>
                        <div className="position-relative">
                            <input
                                type="password"
                                required
                                placeholder="Enter password"
                                className="input-base gray-text-for-content"

                            />
                            <div className="input-start-icon-image"><img src={smsIcon} alt="" /></div>
                        </div>
                    </div>
                </div>
                
                <div className='text-center ' style={{marginTop: "100px"}}>
                    <button type="submit"
              className="dark-orange-button px-4 ">Send Email Confirmation</button>
                </div>
            </form>
            {showPopup && <EmailPopup onClose={handlePopupClose} />}
        </div>

    );
};

export default ChangeEmail;
